export const TENANT_MIGRATED_HEADER = 'x-tenant-migrated';
export const TENANT_MIGRATED_EVENT = 'tenantMigrated';

export const detectMigratedTenant = (headers: any) => {
    if (headers?.[TENANT_MIGRATED_HEADER]) {
        window.dispatchEvent(new Event(TENANT_MIGRATED_EVENT));
    }
};

export const getGen2LoginUrl = (): string | null => window.GEN2_LOGIN_URL || null;
